import React from 'react';
import { Grid, Card, CardContent, Typography, Button, Divider, Box } from '@mui/material';
import Slider from 'react-slick';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
const cardData = [
  {
    id: 1,
    title: 'WINDSOR EV EXCITE',
    price: '₹ 13,99,800',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor%2Fwd_4002ECU_ECL_PW.webp?alt=media&token=b16012f7-2023-4c1a-aed3-da956a3d7520",
    features: [
      'Standard 6 Airbags (Dual Front, Side & Curtain)',
      'Aero-Lounge Seats with 135° recline',
      '25.6 cm (10.1 inch)Infotainment Touch Display',
      'Wireless Android Auto & Apple CarPlay',
      'Electronic Stability Programand Electric Parking Brake'
    ],
  },
  {
    id: 2,
    title: 'WINDSOR EV EXCLUSIVE',
    price: '₹ 15,52,900',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor%2Fwd_4002ECU_ECL_PW.webp?alt=media&token=b16012f7-2023-4c1a-aed3-da956a3d7520",
    features: [
      '39.6 cm(15.6 inch) GrandView Touch Display ',
      '80+ i-Smart Connected Features',
      'R18 Diamond Cut Alloy Wheels',
      '6 Way Power AdjustableDriver Seat',
      '360° Camera',
      'Smart Flush Door Handles'
    ],
  },

  {
    id: 3,
    title: 'WINDSOR EV ESSENCE',
    price: '₹ 16,52,900',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor%2Fwd_4106ECU_ECL_GR.webp?alt=media&token=067c7199-f179-4bc4-a38d-79636329ed81",
    features: [
      'Infinity View Glass Roof',
      '9 Speakers Audio System by Infinity',
      '256 Colour Ambient lights',
      'Ventilated Front Row Seats (Driver & Co-driver)',
      'PM2.5 filter',
    ],
  },
   {
    id: 4,
    title: 'WINDSOR EV EXCLUSIVE PRO',
    price: '₹ 17,37,900',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor%2Fwd_4002ECU_ECL_PW.webp?alt=media&token=b16012f7-2023-4c1a-aed3-da956a3d7520",
    features: [
      '449* km in a Single Charge',
      '52.9 kWh Prismatic Battery',
      'Dual Tone Ivory Interior Highlights',
      '9 Speaker Audio System by Infinity',
      'R18 Dual Tone Machined Alloy Wheels',
      
    ],
  },
{
    id: 5,
    title: 'WINDSOR EV ESSENCE PRO',
    price: '₹ 18,49,900',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor%2Fwd_4106ECU_ECL_AS.webp?alt=media&token=7a5541e7-2715-48ad-a07a-777136f7d212",
    features: [
      '449* km in a single charge',
      'Dual tone ivory interiors',
      'Autonomous level -2 ADAS',
      'Vehicle to Load (V2L)',
      '52.9 kwh prismatic cell battery',
      'Powered tailgate',
      'R18 dual tone machined alloy wheels',
      'Vehicle to Vehicle (V2V)',
      '3 New colours',
    ],
  },
];



const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <ArrowForwardIos
      onClick={onClick}
      style={{
        color: 'black',
        fontSize: '30px',
        position: 'absolute',
        top: '50%',
        right: '10px',
        cursor: 'pointer',
        zIndex: 1
      }}
    />
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <ArrowBackIos
      onClick={onClick}
      style={{
        color: 'black',
        fontSize: '30px',
        position: 'absolute',
        top: '50%',
        left: '10px',
        cursor: 'pointer',
        zIndex: 1
      }}
    />
  );
};
// Carousel settings
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true, // Enable arrows
  nextArrow: <NextArrow />, // Custom next arrow
  prevArrow: <PrevArrow />, // Custom previous arrow
  responsive: [
    {
      breakpoint: 960, // Tablet
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 600, // Mobile
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};


const CardGrid = () => {
  // Define card height
  const cardHeight = { md: '780px', xs: '600px', sm: '850px' };

  return (
    <Box sx={{
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}>
      <Typography variant="h2"
        sx={{
          fontSize: { md: '2.08333vw', xs: '4.2vw' },
          color: '#cf2230',
          fontFamily: 'GillSansSemiBold, Arial, sans-serif',
          paddingBottom: '3.125vw',
          fontWeight: '600',
          marginTop: { md: '80px', xs: '40px', sm: '50px' },
          marginBottom: { xs: '10px' }
        }}>
        MG Windsor Model Variants
      </Typography>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          <Slider {...settings}>
            {cardData.map((card) => (
              <div key={card.id}>
                <Card
                  sx={{
                    height: cardHeight,
                    width: {
                      xs: '75%',  // For small screens
                      sm: '87%',  // For medium screens
                      md: '87%',  // For larger screens
                      lg: '75%'
                    },
                    margin: '5px auto',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '16px',
                    boxSizing: 'border-box',
                    '@media (min-width: 1024px) and (max-width: 1139px)': {
                      width: '300px',
                    },
                  }}
                >
                  <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontFamily: 'GillSansRegular, sans-serif',
                        fontSize: { xs: '4vw', sm: '2.5vw', md: '2vw', lg: '1.27083vw' },
                        color: '#000',
                        marginBottom: '20px',
                      }}
                    >
                      {card.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontFamily: 'Roboto-Regular, sans-serif',
                        fontSize: { xs: '3vw', sm: '1.6vw', md: '1.5vw', lg: '0.84167vw' },
                        color: '#6e6e6e',
                        marginBottom: { xs: '4vw', sm: '3vw', md: '2vw', lg: '1.0416vw' },
                      }}
                    >
                      {card.subtitle}
                    </Typography>
                    <Button
                      sx={{
                        display: 'inline-block',
                        backgroundColor: '#e1e1e1',
                        borderRadius: '5px',
                        textAlign: 'center',
                        padding: '8px 20px',
                        fontFamily: 'GillSansRegular, sans-serif',
                        fontSize: { xs: '4vw', sm: '2.1vw', md: '1.5vw', lg: '0.8167vw' },
                        color: '#000',
                        marginBottom: { xs: '2.1vw', sm: '2vw', md: '1vw', lg: '1.04167vw' },
                        '&:hover': { backgroundColor: '#d4d4d4' },
                      }}
                    >
                      Book Now
                    </Button>
                    <Typography
                      sx={{
                        fontFamily: 'Roboto-Regular, sans-serif',
                        fontSize: { xs: '5vw', sm: '2.6vw', md: '2vw', lg: '0.84167vw' },
                        color: '#6e6e6e',
                        marginBottom: { xs: '2vw', sm: '1.5vw', md: '1vw', lg: '.52083vw' },
                      }}
                    >
                      Starts From
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: 'Roboto-Medium, sans-serif',
                        fontSize: { xs: '5vw', sm: '4vw', md: '3vw', lg: '1.875vw' },
                        color: '#000',
                        marginBottom: 0,
                      }}
                    >
                      {card.price}
                    </Typography>
                    <img
                      src={card.image}
                      alt={card.subtitle}
                      style={{ width: '100%', objectFit: 'cover' }}
                      sx={{
                        height: { xs: '100px', md: '200px' }, // Adjust the height for different screen sizes
                      }}
                    />

                    <ul className="points" style={{ flexGrow: 1 }}>
                      {card.features.map((feature, index) => (
                        <li
                          key={index}
                          style={{
                            fontFamily: 'Roboto-Regular, sans-serif',
                            fontSize: '1.04167vw', // Default for larger screens
                            color: '#000',
                            marginBottom: '1.04167vw',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontWeight: '600',
                              fontSize: { xs: '10px', sm: '12px', md: '1.04167vw' }, // Responsive font sizes
                              '@media (max-width: 425px)': {
                                fontSize: '12px',
                              },
                            }}
                          >
                            {feature}
                          </Typography>
                        </li>
                      ))}
                    </ul>


                    <Divider style={{ color: '#D4D4D5' }} />
                    <Typography
                      sx={{
                        fontFamily: 'Roboto-Regular, sans-serif',
                        fontSize: { md: '.9375vw', xs: '10px' },
                        color: '#000',
                        marginTop: '40px',
                        position: 'absolute',
                        bottom: '30px',
                        width: '100%',
                        textAlign: 'center',
                      }}
                    >
                      Brochure
                    </Typography>
                  </CardContent>
                </Card>
              </div>
            ))}
          </Slider>
        </Grid>
      </Grid>
      {/* <Button
        sx={{
          backgroundColor: '#CF2230',
          color: 'white',
          fontWeight: '700',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontFamily: 'GillSansSemiBold, sans-serif',
          fontSize: { md: '0.95vw', xs: '1.5vw' },
          marginBottom:'40px',
          cursor: 'pointer',
          marginTop: '50px',
          '&:hover': {
            backgroundColor: 'black',
            color: 'white',
          },
        }}
      >
        Compare Variants
      </Button> */}
    </Box>
  );
};

export default CardGrid;